'use client';
import { Stack } from '@mui/material';
import React from 'react';
import {
    LandingPageMatchingSection,
    LandingPageProjectSection,
    LandingPageRegistrationBannerSection,
    LandingPageTargetGroupSection,
    LandingPageTestimonialsSection,
    LandingPageUpperSection
} from './landing-page-sections';
import { Project } from '../../types/Project';
import { Testimonial } from '../../types/Testimonial/domain/testimonial';

type Props = {
    projects: Project[];
    testimonials: Testimonial[];
};

export const LandingPageScreen = ({ projects, testimonials }: Props) => {
    return (
        <Stack sx={{ backgroundColor: 'common.white' }}>
            <LandingPageUpperSection />
            <LandingPageTargetGroupSection />
            <LandingPageMatchingSection />
            <LandingPageProjectSection projects={projects} />
            <LandingPageTestimonialsSection testimonials={testimonials} />
            <LandingPageRegistrationBannerSection />
        </Stack>
    );
};
